<template>
  <b-row>
    <b-col md="12">
      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>
      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <!-- Code -->
          <validation-provider
            #default="validationContext"
            :name="$t('Đơn vị mua tin')"
            rules="required"
          >
            <b-form-group label-for="unit_id">
              <template #label>
                <label
                  class="d-block font-weight-bolder"
                >Đơn vị mua tin <span class="text-danger">*</span></label>
              </template>
              <v-select

                v-model="itemData.unit_ids"
                :options="dataUnits"
                :reduce="(val) => val.id"
                label="name"
                multiple
                size="30"
                placeholder="--Chọn--"
              />
              <b-form-invalid-feedback
                :state="getValidationState(validationContext)"
              >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Sô tiền"
            rules="required"
          >
            <b-form-group>
              <template #label>
                <label
                  class="d-block font-weight-bolder"
                >Sô tiền (VND) <span class="text-danger">*</span></label>
              </template>
              <b-form-input
                id="deposits"
                v-model="itemData.deposits"
                :state="getValidationState(validationContext)"
                @keyup="convertCurrency()"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              :disabled="disabledBtn"
              type="submit"
            >
              <span>{{ $t('Save') }}</span>
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAlert,
  BOverlay,
  BForm,
  BFormGroup,
  BButton,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormTextarea,
  BCardText,
  BFormSelect,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import store from '@/store';
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, alphaNumDot, max } from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import Ripple from 'vue-ripple-directive';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';

import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import vSelect from 'vue-select';

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  props: {
    mdata: Object,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
    };
  },
  computed: {},
  mounted() {},

  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = ref(
      route.value.params.id !== undefined ? route.value.params.id : 0,
    );
    const errorMessage = ref('');
    const dataUnits = ref([]);
    const disabledBtn = ref(false);
    const defaultItemData = {
      deposits: 0,
      unit_ids: '',
    };
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));
    console.log(props)
    const formatPrice = (deposits) => {
      let val = deposits.toString();
      val = val.replace(/,/g, '');

      // eslint-disable-next-line eqeqeq
      if (+val != 0 && !+val) {
        return 0;
      }
      let subString = val.substring(0, 1);
      if (subString === 0 || subString === '0') {
        subString = val.substring(1);
      } else {
        subString = val;
      }
      const hT = subString.split('.');
      const head = hT[0].split('');
      if (head.length > 3) {
        let index = 3;
        while (head.length - index >= 1) {
          head.splice(head.length - index, 0, ',');
          index += 4;
        }
      }
      return hT.length > 1 ? `${head.join('')}.${hT[1]}` : head.join('');
    };
    console.log(props.mdata)
    if (props.mdata.id) {
      itemData.value.deposits = formatPrice(props.mdata.deposits);
      itemData.value = props.mdata;
    }
    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData));
    };
    const { refFormObserver, getValidationState, resetForm } = formValidation(resetItemData);
    const getUnits = () => {
      store
        .dispatch('departments/fetchDepartmentByLevel', { level: 2 })
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            dataUnits.value = response.data.data;
          }
        });
    };
    getUnits();
    const convertCurrency = () => {
      let val = itemData.value.deposits.toString();
      val = val.replace(/,/g, '');

      // eslint-disable-next-line eqeqeq
      if (+val != 0 && !+val) {
        itemData.value.deposits = '';
      } else {
        let subString = val.substring(0, 1);
        if (subString === 0 || subString === '0') {
          subString = val.substring(1);
        } else {
          subString = val;
        }
        const hT = subString.split('.');
        const head = hT[0].split('');
        if (head.length > 3) {
          let index = 3;
          while (head.length - index >= 1) {
            head.splice(head.length - index, 0, ',');
            index += 4;
          }
        }
        itemData.value.deposits = hT.length > 1 ? `${head.join('')}.${hT[1]}` : head.join('');
      }
    };
    const onSubmit = () => {
      errorMessage.value = '';
      disabledBtn.value = true;
      console.log(!+itemData.value.deposits)
      if (!+itemData.value.deposits) {
        itemData.value.deposits = itemData.value.deposits.replaceAll(',', '');
      }

      if (itemData.value.id) {
        store
          .dispatch('sellNews/updateUnitBuy', {
            data: itemData.value,
            id: itemData.value.id,
          })
          .then((response) => {
            if (response.status === 200) {
              disabledBtn.value = false;
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                resetForm();
                emit('updateData');
              } else {
                showToast(response.data.message);
                errorMessage.value = response.data.message;
              }
            } else {
              disabledBtn.value = false;
              showToast(response.data.message);
              itemData.value.deposits = this.convertCurrency(itemData.value.deposits);
            }
          });
      } else {
        store
          .dispatch('sellNews/createUnitBuy', itemData.value)
          .then((response) => {
            if (response.status === 200) {
              disabledBtn.value = false;
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                resetForm();
                emit('updateData');
              } else {
                showToast(response.data.message);
                errorMessage.value = response.data.message;
              }
            } else {
              disabledBtn.value = false;
              itemData.value.deposits = this.convertCurrency(itemData.value.deposits);
            }
          });
      }
    };
    Vietnamese.rangeSeparator = ' - ';
    const configDate = ref({
      dateFormat: 'd/m/Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance onlyf
    });

    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      disabledBtn,
      dataUnits,
      configDate,
      convertCurrency,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
